import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

export default function MarketConnectionPanel() {
  const [status, setStatus] = useState(null);
  const [username, setUsername] = useState('');
  const [key, setKey] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const refresh = async () => {
    try { setStatus((await api.get('/admin/market-data/connection')).data); }
    catch { setStatus(null); setMessage('Connection status could not be loaded.'); }
  };
  useEffect(() => { refresh(); }, []);
  const save = async event => {
    event.preventDefault(); if (!status || busy) return;
    setBusy(true); setMessage('Checking broker authentication and historical candles…');
    try {
      const response = await api.put('/admin/market-data/connection', { username, api_key: key, expected_revision: status.credential_revision });
      setStatus(response.data); setKey('');
      setMessage('Connection validated and saved. Candle requests use it immediately; the quote stream reconnects automatically. Trading credentials are unchanged.');
    } catch { setKey(''); setMessage('Connection was not changed. Refresh status and check the credentials or broker availability.'); }
    finally { setBusy(false); }
  };
  return <Card className="bg-zinc-900 border-zinc-800">
    <CardHeader><CardTitle>TopstepX platform market-data connection</CardTitle></CardHeader>
    <CardContent><p className="text-sm mb-3">Shared candles and quotes. This connection does not enable trading or change account ownership.</p>
      <p className="text-sm">Source: {status?.source || 'Unknown'} · Configured: {status ? String(status.configured) : 'Unknown'}</p>
      <p className="text-xs mb-3">Last successful validation: {status?.last_validated_at || 'Not recorded'}</p>
      <form onSubmit={save} className="space-y-3">
        <label className="block">Broker username<Input value={username} onChange={e => setUsername(e.target.value)} autoComplete="off" required disabled={busy} /></label>
        <label className="block">New API key<Input type="password" value={key} onChange={e => setKey(e.target.value)} autoComplete="new-password" required disabled={busy} /></label>
        <Button type="submit" disabled={!status || busy || !username.trim() || !key.trim()}>Validate candles and save</Button>
        <Button type="button" variant="outline" disabled={busy} onClick={refresh}>Refresh status</Button>
      </form>
      {message && <p role="status" className="text-sm mt-3">{message}</p>}
    </CardContent>
  </Card>;
}
